"use client";

import React, { useEffect, useState } from "react";
import { ShieldCheck, Clock, Activity, Cloud, Sun, CloudRain, CloudLightning, Wind } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
function HongKongWeather() {
  const [weather, setWeather] = useState<{
    temp: number;
    description: string;
    icon: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=Hong%20Kong&units=metric&appid=895284fb2d2c1d87f45e207f96f47311`);
        if (!response.ok) throw new Error("Weather data unavailable");
        const data = await response.json();
        setWeather({
          temp: Math.round(data.main.temp),
          description: data.weather[0].main,
          icon: data.weather[0].main
        });
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchWeather();
  }, []);
  const getWeatherIcon = (condition: string) => {
    switch (condition.toLowerCase()) {
      case "clouds":
        return <Cloud className="size-3 text-primary/60" />;
      case "clear":
        return <Sun className="size-3 text-ring" />;
      case "rain":
        return <CloudRain className="size-3 text-primary/60" />;
      case "thunderstorm":
        return <CloudLightning className="size-3 text-primary/60" />;
      default:
        return <Wind className="size-3 text-primary/60" />;
    }
  };
  if (loading) {
    return <div className="flex justify-between items-center font-sans text-xs animate-pulse">
        <span className="text-muted-foreground font-medium uppercase tracking-widest">Weather</span>
        <div className="h-3 w-16 bg-muted rounded-md" />
      </div>;
  }
  if (error || !weather) {
    return;
  }
  return <div className="flex justify-between items-center font-sans text-xs">
      <span className="text-muted-foreground font-medium uppercase tracking-widest">Weather</span>
      <span className="text-primary font-semibold flex items-center gap-2">
        {getWeatherIcon(weather.icon)}
        {weather.temp}°C • {weather.description}
      </span>
    </div>;
}
function LiveClock() {
  const [time, setTime] = useState<Date | null>(null);
  useEffect(() => {
    setTime(new Date());
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);
  if (!time) {
    return <div data-section-id="223533" className="font-mono text-4xl font-light tracking-widest text-primary/50">
        00:00:00
      </div>;
  }
  return <div className="flex flex-col gap-1">
      <div className="font-default text-4xl md:text-5xl font-semibold tracking-tight text-primary">
        {time.toLocaleTimeString("en-US", {
        hour12: false,
        timeZone: "Asia/Hong_Kong"
      })}
      </div>
      <div className="flex items-center gap-2 text-xs font-sans text-muted-foreground uppercase tracking-widest">
        <Activity className="size-3 text-secondary animate-pulse" />
        Hong Kong Time (Local)
      </div>
    </div>;
}
export default function TheBriefingRoom() {
  return;
}